import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Forma_cumpl } from 'src/app/models/forma_cumpl.model';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-forma-cumplimiento',
  templateUrl: './forma-cumplimiento.component.html',
  styleUrls: ['./forma-cumplimiento.component.css']
})
export class FormaCumplimientoComponent {

  public rows = [];
  public actualRow;
  public forma_cumpl: Forma_cumpl;
  public form;
  public formulario;
  public num;

  public matcher = new FormService();

  constructor() {
    this.formulario = localStorage.getItem("form")

    if (this.formulario == "1-1.1") {
      this.num = '6.5';
    }

    this.form = new FormGroup({
      forma_cumpl: new FormControl(''),
      forma_cumpl_esp: new FormControl(''),
    })

    if (!JSON.parse(localStorage.getItem("forma_cumpl"))) {
      localStorage.setItem("forma_cumpl", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("forma_cumpl"));
      this.form.controls['forma_cumpl'].setValue(this.rows[0] ? this.rows[0].forma_cumpl : '')
      this.form.controls['forma_cumpl_esp'].setValue(this.rows[0] ? this.rows[0].forma_cumpl_esp : '')

    }

  }

  add_forma_cumpl() {
    localStorage.setItem("forma_cumpl", JSON.stringify([]));
    this.actualRow = localStorage.getItem("forma_cumpl");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      forma_cumpl: this.form.value.forma_cumpl,
      forma_cumpl_esp: this.form.value.forma_cumpl_esp

    })
    localStorage.setItem("forma_cumpl", JSON.stringify(this.rows));
  }

  delete_normas(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("forma_cumpl", JSON.stringify(this.rows));
      }
    }
  }

}
